import { render } from "./AppWizard.vue?vue&type=template&id=9f7e9b3a&scoped=true"
import script from "./AppWizard.vue?vue&type=script&lang=js"
export * from "./AppWizard.vue?vue&type=script&lang=js"

import "./AppWizard.vue?vue&type=style&index=0&id=9f7e9b3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7e9b3a"]])

export default __exports__